import React, {VoidFunctionComponent} from 'react';
import {useHistory} from 'react-router-dom';

import IconButton from '../icon-button/icon-button';
import InfoIcon from '../icons/info/info';

import styles from './info-button.module.css';

const InfoButton: VoidFunctionComponent<Record<string, unknown>> = () => {
  const history = useHistory();

  const showInfoScreen = () => {
    history.push('/info');
  };

  return (
    <IconButton
      className={styles.infoButton}
      variant="secondary"
      onClick={showInfoScreen}>
      <InfoIcon />
    </IconButton>
  );
};

export default InfoButton;
